import { useState, useMemo } from "react";
import { formatINR } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";

export default function RegistryCost() {
  const [value, setValue] = useState("5000000");
  const [stampPct, setStampPct] = useState("7");
  const [regPct, setRegPct] = useState("1");
  const [misc, setMisc] = useState("15000");

  const { stamp, reg, total } = useMemo(() => {
    const v = Number(value) || 0;
    const stamp = v * ((Number(stampPct) || 0) / 100);
    const reg = v * ((Number(regPct) || 0) / 100);
    return { stamp, reg, total: stamp + reg + (Number(misc) || 0) };
  }, [value, stampPct, regPct, misc]);

  const rows = [
    ["Property Value", formatINR(Number(value) || 0)],
    [`Stamp Duty (${stampPct}%)`, formatINR(stamp)],
    [`Registration (${regPct}%)`, formatINR(reg)],
    ["Miscellaneous", formatINR(Number(misc) || 0)],
    ["Total Payable", formatINR(total)],
  ];

  return (
    <div>
      <CalcPageHeader title="Registry Cost Calculator" description="Fully custom stamp, registration and miscellaneous charge computation." slug="registry" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 space-y-4">
            <Field label="Property Value (₹)"><input data-testid="registry-value-input" type="number" value={value} onChange={(e)=>setValue(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <div className="grid grid-cols-2 gap-4">
              <Field label="Stamp %"><input data-testid="registry-stamp-pct" type="number" value={stampPct} onChange={(e)=>setStampPct(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
              <Field label="Registration %"><input data-testid="registry-reg-pct" type="number" value={regPct} onChange={(e)=>setRegPct(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            </div>
            <Field label="Miscellaneous (₹)" hint="Legal, notary, e-stamp handling, etc."><input data-testid="registry-misc-input" type="number" value={misc} onChange={(e)=>setMisc(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Registry Cost" slug="registry" highlight={{ label: "Total Payable", value: formatINR(total) }} rows={rows} onReset={()=>{setValue("");setMisc("0");}} />
        </div>
      </div>
    </div>
  );
}
